import { Injectable } from '@angular/core';
import { BaseApiClientSystemsService } from './base-api-client-systems.service';

@Injectable({
  providedIn: 'root'
})
export class ApiClientSystemsService extends BaseApiClientSystemsService {}
